// action
import {
    GET_ARTICLE_HOME_LIST,
    GET_ARTICLE_HOME_LIST_FAIL,
    GET_ARTICLE_HOME_LIST_SUCCESS,
    GET_ARTICLE_HOME_LIST_RESET
} from '../action/getArticleHomeListAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    text_articles: [],
    video_articles: [],
    audio_articles: [],
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_ARTICLE_HOME_LIST:
            return {
                ...state,
                apiState: "loading"
            }
        case GET_ARTICLE_HOME_LIST_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case GET_ARTICLE_HOME_LIST_SUCCESS:
            return {
                ...state,
                apiState: "success",
                text_articles: action.response.data.data.text_articles,
                video_articles: action.response.data.data.video_articles,
                audio_articles: action.response.data.data.audio_articles,
            }
        case GET_ARTICLE_HOME_LIST_RESET:
            return initialState
        default:
            return state
    }
}